// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.03%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Hero ───────────────────────────────────── */
.af-hero {
  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 60%, #4f46e5 100%);
  min-height: 500px;
  padding: 80px 20px 72px;
  position: relative;
  overflow: hidden;
  text-align: center;
}
.af-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.af-hero-center {
  max-width: 640px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.af-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #3730a3;
  border: 1px solid #4f46e5;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
}

.af-hero h1 {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 900;
  color: #fff;
  letter-spacing: -1px;
  line-height: 1.1;
  margin-bottom: 16px;
}

.af-hero-sub {
  font-size: 1rem;
  color: rgba(255,255,255,0.75);
  line-height: 1.65;
  max-width: 500px;
  margin: 0 auto;
}

.af-hero-trust {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
}

.af-hero-trust span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: rgba(255,255,255,0.6);
  font-weight: 600;
}

.af-hero-trust span svg { color: #a5b4fc; }

/* ── Stats ───────────────────────────────────── */
.af-stats {
  background: #fff;
  border-bottom: 1px solid var(--border);
}

.af-stats-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 36px 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  text-align: center;
}

.af-stat-val {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 900;
  background: var(--grad);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -1px;
  line-height: 1;
}

.af-stat-label {
  font-size: 0.85rem;
  color: var(--muted);
  margin-top: 4px;
  font-weight: 600;
}

/* ── Shared section helpers ──────────────────── */
.af-section-head {
  text-align: center;
  margin-bottom: 52px;
}

/* ── Commissions ─────────────────────────────── */
.af-commissions {
  padding: 80px 20px;
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
}

.af-comm-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 28px;
}

.af-comm-card {
  background: #fff;
  border: 1.5px solid var(--border);
  border-radius: 18px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  position: relative;
  text-align: left;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.af-comm-card:hover {
  border-color: var(--p1);
  box-shadow: 0 4px 24px rgba(79,70,229,0.08);
}

.af-comm-card--featured {
  border-color: var(--p1);
  box-shadow: 0 4px 24px rgba(79,70,229,0.1);
}

.af-comm-badge {
  position: absolute;
  top: -12px;
  left: 24px;
  background: var(--grad);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 20px;
}

.af-comm-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #eef2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--p1);
}

.af-comm-value {
  font-size: 2.2rem;
  font-weight: 900;
  background: var(--grad);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -1px;
  line-height: 1;
}

.af-comm-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text);
}

.af-comm-desc {
  font-size: 0.85rem;
  color: var(--muted);
  line-height: 1.6;
}

.af-comm-note {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
  color: var(--muted);
  background: #f4f4f5;
  border-radius: 12px;
  padding: 12px 20px;
}

.af-comm-note svg { color: var(--p1); flex-shrink: 0; }

/* ── Perks ───────────────────────────────────── */
.af-perks {
  padding: 80px 20px;
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
  background: var(--bg);
}

/* needed when section has no bg class */
section:has(.af-perks) { background: var(--bg); }

.af-perks-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px;
  text-align: left;
}

.af-perk { display: flex; flex-direction: column; gap: 10px; }

.af-perk-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #eef2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--p1);
}

.af-perk-title { font-size: 0.95rem; font-weight: 700; color: var(--text); }
.af-perk-desc  { font-size: 0.85rem; color: var(--muted); line-height: 1.6; }

.af-perks-cta {
  margin-top: 44px;
  display: flex;
  justify-content: center;
}

/* ── Simulator ───────────────────────────────── */
.af-sim-section {
  background: #f8f8fb;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  padding: 80px 20px;
}

.af-sim-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}

.af-sim-text {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.af-sim-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.af-sim-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.af-sim-label {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--muted);
}

.af-sim-count {
  font-size: 2rem;
  font-weight: 900;
  background: var(--grad);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -1px;
}

.af-range {
  width: 100%;
  -webkit-appearance: none;
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(90deg, var(--p1) 0%, var(--p2) 100%);
  outline: none;
  cursor: pointer;
}
.af-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--p1);
  border: 3px solid #fff;
  box-shadow: 0 2px 8px rgba(79,70,229,0.35);
  cursor: pointer;
}

.af-sim-breakdown {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-top: 1px solid var(--border);
  padding-top: 16px;
}

.af-sim-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.88rem;
}
.af-sim-row span { color: var(--muted); }
.af-sim-row small { font-size: 0.78rem; opacity: 0.7; }
.af-sim-row strong { color: var(--text); font-weight: 700; }

.af-sim-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #eef2ff;
  border-radius: 12px;
  padding: 16px 20px;
}
.af-sim-total span { font-size: 0.85rem; font-weight: 700; color: var(--p1); }
.af-sim-total strong {
  font-size: 1.6rem;
  font-weight: 900;
  background: var(--grad);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -1px;
}

/* ── Steps ───────────────────────────────────── */
.af-steps-section {
  background: #f8f8fb;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  padding: 80px 20px;
}

.af-steps-inner {
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
}

.af-steps-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.af-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.af-step-num {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--grad);
  color: #fff;
  font-size: 1.2rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(79,70,229,0.28);
}

.af-step-title { font-size: 1rem; font-weight: 700; color: var(--text); }
.af-step-desc  { font-size: 0.88rem; color: var(--muted); line-height: 1.6; }

/* ── FAQ ─────────────────────────────────────── */
.af-faq {
  padding: 80px 20px;
  max-width: 740px;
  margin: 0 auto;
}

.af-faq-title {
  font-size: 1.6rem;
  font-weight: 800;
  text-align: center;
  color: var(--text);
  margin-bottom: 36px;
  letter-spacing: -0.4px;
}

.af-faq-item {
  border: 1px solid var(--border);
  border-radius: 12px;
  margin-bottom: 8px;
  overflow: hidden;
  background: #fff;
}

.af-faq-q {
  width: 100%;
  background: none;
  border: none;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text);
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  gap: 12px;
  transition: background 0.15s;
}
.af-faq-q:hover { background: #fafafa; }

.af-faq-icon {
  flex-shrink: 0;
  color: var(--p1);
  transition: transform 0.2s;
}
.af-faq-icon.open { transform: rotate(180deg); }

.af-faq-a {
  padding: 0 20px 18px;
  font-size: 0.88rem;
  color: var(--muted);
  line-height: 1.65;
}

/* ── Bottom CTA ──────────────────────────────── */
.af-bottom-cta {
  background: linear-gradient(135deg, #1e1b4b, #4f46e5);
  padding: 72px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.af-bottom-cta::before {
  content: '';
  position: absolute;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: rgba(255,255,255,0.05);
  top: -80px;
  right: -80px;
}

.af-bottom-cta-inner {
  max-width: 540px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.af-bottom-cta h2 {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 900;
  color: #fff;
  letter-spacing: -0.5px;
  margin-bottom: 8px;
}

.af-bottom-cta p {
  color: rgba(255,255,255,0.75);
  margin-bottom: 28px;
  font-size: 0.95rem;
}

.af-bottom-form {
  display: flex;
  gap: 10px;
  max-width: 420px;
  margin: 0 auto;
}

.af-bottom-form input {
  flex: 1 1;
  border: none;
  border-radius: 12px;
  padding: 13px 16px;
  font-size: 0.92rem;
  font-family: inherit;
  outline: none;
}

.af-bottom-form button {
  background: #fff;
  color: var(--p1);
  border: none;
  border-radius: 12px;
  padding: 13px 22px;
  font-size: 0.92rem;
  font-weight: 800;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: opacity 0.2s;
}
.af-bottom-form button:hover { opacity: 0.9; }

/* ── Modal ───────────────────────────────────── */
.af-modal {
  background: #fff;
  border-radius: 20px;
  width: min(640px, calc(100% - 32px));
  max-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 64px rgba(0,0,0,0.3);
  border: none;
  padding: 0;
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
}

.af-modal::backdrop {
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(2px);
}

.af-modal-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 28px 16px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.af-modal-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--text);
  letter-spacing: -0.3px;
}

.af-modal-sub {
  font-size: 0.82rem;
  color: var(--muted);
  margin-top: 2px;
}

.af-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--muted);
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 8px;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
}
.af-modal-close:hover { background: #f3f4f6; color: var(--text); }

.af-modal-body {
  overflow-y: auto;
  padding: 24px 28px 28px;
  flex: 1 1;
}

.af-modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}

/* ── Form fields ─────────────────────────────── */
.af-field {
  margin-bottom: 14px;
}

.af-field label {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 5px;
}

.af-field input {
  width: 100%;
  border: 1.5px solid var(--border);
  border-radius: 10px;
  padding: 11px 14px;
  font-size: 0.95rem;
  font-family: inherit;
  color: var(--text);
  background: #f9fafb;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
}
.af-field input:focus { border-color: var(--p1); background: #fff; }

.af-pass-wrap {
  display: flex;
  align-items: center;
  border: 1.5px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: #f9fafb;
  transition: border-color 0.2s;
}
.af-pass-wrap:focus-within { border-color: var(--p1); background: #fff; }

.af-prefix {
  padding: 0 10px;
  font-size: 0.82rem;
  color: var(--muted);
  border-right: 1.5px solid var(--border);
  height: 44px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
  background: #f3f4f6;
}

.af-prefixed {
  flex: 1 1;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  padding: 11px 14px;
  font-size: 0.95rem;
  font-family: inherit;
  color: var(--text);
  outline: none;
}

.af-input-group {
  display: flex;
  align-items: center;
  border: 1.5px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: #f9fafb;
  transition: border-color 0.2s;
}
.af-input-group:focus-within { border-color: var(--p1); background: #fff; }
.af-input-group--ok  { border-color: #10b981 !important; }
.af-input-group--err { border-color: #ef4444 !important; }

.af-code-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.74rem;
  font-weight: 600;
  color: var(--muted);
  margin-top: 4px;
}
.af-hint-ok  { color: #10b981; }
.af-hint-err { color: #ef4444; }

.af-submit {
  width: 100%;
  background: var(--grad);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  margin-top: 6px;
  transition: opacity 0.2s, transform 0.15s;
}
.af-submit:hover { opacity: 0.92; transform: translateY(-1px); }
.af-submit:disabled { opacity: 0.45; cursor: not-allowed; transform: none; }

.af-form-note {
  font-size: 0.74rem;
  color: var(--muted2);
  text-align: center;
  margin-top: 10px;
  line-height: 1.5;
}

/* ── Alert ───────────────────────────────────── */
.af-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 0.84rem;
  line-height: 1.5;
  margin-bottom: 16px;
}
.af-alert-ok  { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }
.af-alert-err { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }

/* ── Responsive ──────────────────────────────── */
@media (max-width: 860px) {
  .af-perks-grid { grid-template-columns: repeat(2, 1fr); }
  .af-steps-grid { grid-template-columns: 1fr; gap: 24px; }
  .af-stats-inner { grid-template-columns: 1fr; }
  .af-bottom-form { flex-direction: column; }
  .af-comm-grid { grid-template-columns: 1fr; }
  .af-sim-inner { grid-template-columns: 1fr; gap: 36px; }
}

@media (max-width: 520px) {
  .af-modal-grid { grid-template-columns: 1fr; }
  .af-modal-head { padding: 20px 20px 14px; }
  .af-modal-body { padding: 16px 20px 24px; }
  .af-perks-grid { grid-template-columns: 1fr; }
  .af-hero-trust { flex-direction: column; gap: 8px; }
}

@media (max-height: 760px) {
  .af-modal { top: 64px; max-height: calc(100vh - 88px); }
}
`, "",{"version":3,"sources":["webpack://./src/components/Affiliate.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,0EAA0E;EAC1E,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mDAA8X;AAChY;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,0BAA0B,cAAc,EAAE;;AAE1C,mDAAmD;AACnD;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB,gBAAgB,EAAE,cAAc,EAAE;;AAEtD,mDAAmD;AACnD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC,yBAAyB,qBAAqB,EAAE;;AAEhD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE7D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC3E,iBAAiB,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE5E;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,gEAAgE;EAChE,aAAa;EACb,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA,mBAAmB,mBAAmB,EAAE;AACxC,oBAAoB,kBAAkB,EAAE,YAAY,EAAE;AACtD,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE;;AAE3D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC7E;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACxE,iBAAiB,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE5E,mDAAmD;AACnD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,4BAA4B;AAC9B;AACA,kBAAkB,mBAAmB,EAAE;;AAEvC;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,oBAAoB,yBAAyB,EAAE;;AAE/C;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,qDAAqD;EACrD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA,+BAA+B,YAAY,EAAE;;AAE7C,mDAAmD;AACnD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;EACZ,UAAU;EACV,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;AACA,wBAAwB,mBAAmB,EAAE,kBAAkB,EAAE;;AAEjE;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;AACA,wBAAwB,uBAAuB,EAAE,gBAAgB,EAAE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,6BAA6B,uBAAuB,EAAE,gBAAgB,EAAE;;AAExE;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,+BAA+B,uBAAuB,EAAE,gBAAgB,EAAE;AAC1E,uBAAuB,gCAAgC,EAAE;AACzD,uBAAuB,gCAAgC,EAAE;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA,eAAe,cAAc,EAAE;AAC/B,eAAe,cAAc,EAAE;;AAE/B;EACE,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,yCAAyC;AAC3C;AACA,mBAAmB,aAAa,EAAE,2BAA2B,EAAE;AAC/D,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAE3E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAChF,gBAAgB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAEhF,mDAAmD;AACnD;EACE,iBAAiB,qCAAqC,EAAE;EACxD,iBAAiB,0BAA0B,EAAE,SAAS,EAAE;EACxD,kBAAkB,0BAA0B,EAAE;EAC9C,kBAAkB,sBAAsB,EAAE;EAC1C,gBAAgB,0BAA0B,EAAE;EAC5C,gBAAgB,0BAA0B,EAAE,SAAS,EAAE;AACzD;;AAEA;EACE,iBAAiB,0BAA0B,EAAE;EAC7C,iBAAiB,uBAAuB,EAAE;EAC1C,iBAAiB,uBAAuB,EAAE;EAC1C,iBAAiB,0BAA0B,EAAE;EAC7C,iBAAiB,sBAAsB,EAAE,QAAQ,EAAE;AACrD;;AAEA;EACE,YAAY,SAAS,EAAE,8BAA8B,EAAE;AACzD","sourcesContent":["/* ── Hero ───────────────────────────────────── */\n.af-hero {\n  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 60%, #4f46e5 100%);\n  min-height: 500px;\n  padding: 80px 20px 72px;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n}\n.af-hero::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.af-hero-center {\n  max-width: 640px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.af-hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #3730a3;\n  border: 1px solid #4f46e5;\n  border-radius: 20px;\n  padding: 5px 14px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 0.5px;\n  margin-bottom: 20px;\n}\n\n.af-hero h1 {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 900;\n  color: #fff;\n  letter-spacing: -1px;\n  line-height: 1.1;\n  margin-bottom: 16px;\n}\n\n.af-hero-sub {\n  font-size: 1rem;\n  color: rgba(255,255,255,0.75);\n  line-height: 1.65;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.af-hero-trust {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.af-hero-trust span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.8rem;\n  color: rgba(255,255,255,0.6);\n  font-weight: 600;\n}\n\n.af-hero-trust span svg { color: #a5b4fc; }\n\n/* ── Stats ───────────────────────────────────── */\n.af-stats {\n  background: #fff;\n  border-bottom: 1px solid var(--border);\n}\n\n.af-stats-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 36px 20px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  text-align: center;\n}\n\n.af-stat-val {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 900;\n  background: var(--grad);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -1px;\n  line-height: 1;\n}\n\n.af-stat-label {\n  font-size: 0.85rem;\n  color: var(--muted);\n  margin-top: 4px;\n  font-weight: 600;\n}\n\n/* ── Shared section helpers ──────────────────── */\n.af-section-head {\n  text-align: center;\n  margin-bottom: 52px;\n}\n\n/* ── Commissions ─────────────────────────────── */\n.af-commissions {\n  padding: 80px 20px;\n  max-width: 1100px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.af-comm-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\n.af-comm-card {\n  background: #fff;\n  border: 1.5px solid var(--border);\n  border-radius: 18px;\n  padding: 32px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  position: relative;\n  text-align: left;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.af-comm-card:hover {\n  border-color: var(--p1);\n  box-shadow: 0 4px 24px rgba(79,70,229,0.08);\n}\n\n.af-comm-card--featured {\n  border-color: var(--p1);\n  box-shadow: 0 4px 24px rgba(79,70,229,0.1);\n}\n\n.af-comm-badge {\n  position: absolute;\n  top: -12px;\n  left: 24px;\n  background: var(--grad);\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n\n.af-comm-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  background: #eef2ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--p1);\n}\n\n.af-comm-value {\n  font-size: 2.2rem;\n  font-weight: 900;\n  background: var(--grad);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -1px;\n  line-height: 1;\n}\n\n.af-comm-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.af-comm-desc {\n  font-size: 0.85rem;\n  color: var(--muted);\n  line-height: 1.6;\n}\n\n.af-comm-note {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.88rem;\n  color: var(--muted);\n  background: #f4f4f5;\n  border-radius: 12px;\n  padding: 12px 20px;\n}\n\n.af-comm-note svg { color: var(--p1); flex-shrink: 0; }\n\n/* ── Perks ───────────────────────────────────── */\n.af-perks {\n  padding: 80px 20px;\n  max-width: 1100px;\n  margin: 0 auto;\n  text-align: center;\n  background: var(--bg);\n}\n\n/* needed when section has no bg class */\nsection:has(.af-perks) { background: var(--bg); }\n\n.af-perks-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 28px;\n  text-align: left;\n}\n\n.af-perk { display: flex; flex-direction: column; gap: 10px; }\n\n.af-perk-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  background: #eef2ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--p1);\n}\n\n.af-perk-title { font-size: 0.95rem; font-weight: 700; color: var(--text); }\n.af-perk-desc  { font-size: 0.85rem; color: var(--muted); line-height: 1.6; }\n\n.af-perks-cta {\n  margin-top: 44px;\n  display: flex;\n  justify-content: center;\n}\n\n/* ── Simulator ───────────────────────────────── */\n.af-sim-section {\n  background: #f8f8fb;\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  padding: 80px 20px;\n}\n\n.af-sim-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 64px;\n  align-items: center;\n}\n\n.af-sim-text {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.af-sim-card {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 20px;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.05);\n}\n\n.af-sim-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.af-sim-label {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--muted);\n}\n\n.af-sim-count {\n  font-size: 2rem;\n  font-weight: 900;\n  background: var(--grad);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -1px;\n}\n\n.af-range {\n  width: 100%;\n  -webkit-appearance: none;\n  height: 6px;\n  border-radius: 3px;\n  background: linear-gradient(90deg, var(--p1) 0%, var(--p2) 100%);\n  outline: none;\n  cursor: pointer;\n}\n.af-range::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--p1);\n  border: 3px solid #fff;\n  box-shadow: 0 2px 8px rgba(79,70,229,0.35);\n  cursor: pointer;\n}\n\n.af-sim-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-top: 1px solid var(--border);\n  padding-top: 16px;\n}\n\n.af-sim-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.88rem;\n}\n.af-sim-row span { color: var(--muted); }\n.af-sim-row small { font-size: 0.78rem; opacity: 0.7; }\n.af-sim-row strong { color: var(--text); font-weight: 700; }\n\n.af-sim-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #eef2ff;\n  border-radius: 12px;\n  padding: 16px 20px;\n}\n.af-sim-total span { font-size: 0.85rem; font-weight: 700; color: var(--p1); }\n.af-sim-total strong {\n  font-size: 1.6rem;\n  font-weight: 900;\n  background: var(--grad);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -1px;\n}\n\n/* ── Steps ───────────────────────────────────── */\n.af-steps-section {\n  background: #f8f8fb;\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  padding: 80px 20px;\n}\n\n.af-steps-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.af-steps-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n}\n\n.af-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n}\n\n.af-step-num {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--grad);\n  color: #fff;\n  font-size: 1.2rem;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(79,70,229,0.28);\n}\n\n.af-step-title { font-size: 1rem; font-weight: 700; color: var(--text); }\n.af-step-desc  { font-size: 0.88rem; color: var(--muted); line-height: 1.6; }\n\n/* ── FAQ ─────────────────────────────────────── */\n.af-faq {\n  padding: 80px 20px;\n  max-width: 740px;\n  margin: 0 auto;\n}\n\n.af-faq-title {\n  font-size: 1.6rem;\n  font-weight: 800;\n  text-align: center;\n  color: var(--text);\n  margin-bottom: 36px;\n  letter-spacing: -0.4px;\n}\n\n.af-faq-item {\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  margin-bottom: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.af-faq-q {\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 18px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text);\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  gap: 12px;\n  transition: background 0.15s;\n}\n.af-faq-q:hover { background: #fafafa; }\n\n.af-faq-icon {\n  flex-shrink: 0;\n  color: var(--p1);\n  transition: transform 0.2s;\n}\n.af-faq-icon.open { transform: rotate(180deg); }\n\n.af-faq-a {\n  padding: 0 20px 18px;\n  font-size: 0.88rem;\n  color: var(--muted);\n  line-height: 1.65;\n}\n\n/* ── Bottom CTA ──────────────────────────────── */\n.af-bottom-cta {\n  background: linear-gradient(135deg, #1e1b4b, #4f46e5);\n  padding: 72px 20px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.af-bottom-cta::before {\n  content: '';\n  position: absolute;\n  width: 320px;\n  height: 320px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.05);\n  top: -80px;\n  right: -80px;\n}\n\n.af-bottom-cta-inner {\n  max-width: 540px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.af-bottom-cta h2 {\n  font-size: clamp(1.6rem, 3vw, 2.2rem);\n  font-weight: 900;\n  color: #fff;\n  letter-spacing: -0.5px;\n  margin-bottom: 8px;\n}\n\n.af-bottom-cta p {\n  color: rgba(255,255,255,0.75);\n  margin-bottom: 28px;\n  font-size: 0.95rem;\n}\n\n.af-bottom-form {\n  display: flex;\n  gap: 10px;\n  max-width: 420px;\n  margin: 0 auto;\n}\n\n.af-bottom-form input {\n  flex: 1;\n  border: none;\n  border-radius: 12px;\n  padding: 13px 16px;\n  font-size: 0.92rem;\n  font-family: inherit;\n  outline: none;\n}\n\n.af-bottom-form button {\n  background: #fff;\n  color: var(--p1);\n  border: none;\n  border-radius: 12px;\n  padding: 13px 22px;\n  font-size: 0.92rem;\n  font-weight: 800;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  transition: opacity 0.2s;\n}\n.af-bottom-form button:hover { opacity: 0.9; }\n\n/* ── Modal ───────────────────────────────────── */\n.af-modal {\n  background: #fff;\n  border-radius: 20px;\n  width: min(640px, calc(100% - 32px));\n  max-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 64px rgba(0,0,0,0.3);\n  border: none;\n  padding: 0;\n  position: fixed;\n  top: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.af-modal::backdrop {\n  background: rgba(0,0,0,0.55);\n  backdrop-filter: blur(2px);\n}\n\n.af-modal-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 24px 28px 16px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.af-modal-title {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: var(--text);\n  letter-spacing: -0.3px;\n}\n\n.af-modal-sub {\n  font-size: 0.82rem;\n  color: var(--muted);\n  margin-top: 2px;\n}\n\n.af-modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--muted);\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  border-radius: 8px;\n  transition: background 0.15s, color 0.15s;\n  flex-shrink: 0;\n}\n.af-modal-close:hover { background: #f3f4f6; color: var(--text); }\n\n.af-modal-body {\n  overflow-y: auto;\n  padding: 24px 28px 28px;\n  flex: 1;\n}\n\n.af-modal-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 16px;\n}\n\n/* ── Form fields ─────────────────────────────── */\n.af-field {\n  margin-bottom: 14px;\n}\n\n.af-field label {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 5px;\n}\n\n.af-field input {\n  width: 100%;\n  border: 1.5px solid var(--border);\n  border-radius: 10px;\n  padding: 11px 14px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  color: var(--text);\n  background: #f9fafb;\n  outline: none;\n  transition: border-color 0.2s, background 0.2s;\n}\n.af-field input:focus { border-color: var(--p1); background: #fff; }\n\n.af-pass-wrap {\n  display: flex;\n  align-items: center;\n  border: 1.5px solid var(--border);\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f9fafb;\n  transition: border-color 0.2s;\n}\n.af-pass-wrap:focus-within { border-color: var(--p1); background: #fff; }\n\n.af-prefix {\n  padding: 0 10px;\n  font-size: 0.82rem;\n  color: var(--muted);\n  border-right: 1.5px solid var(--border);\n  height: 44px;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  flex-shrink: 0;\n  background: #f3f4f6;\n}\n\n.af-prefixed {\n  flex: 1;\n  border: none !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  padding: 11px 14px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  color: var(--text);\n  outline: none;\n}\n\n.af-input-group {\n  display: flex;\n  align-items: center;\n  border: 1.5px solid var(--border);\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f9fafb;\n  transition: border-color 0.2s;\n}\n.af-input-group:focus-within { border-color: var(--p1); background: #fff; }\n.af-input-group--ok  { border-color: #10b981 !important; }\n.af-input-group--err { border-color: #ef4444 !important; }\n\n.af-code-hint {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: var(--muted);\n  margin-top: 4px;\n}\n.af-hint-ok  { color: #10b981; }\n.af-hint-err { color: #ef4444; }\n\n.af-submit {\n  width: 100%;\n  background: var(--grad);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 14px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: inherit;\n  margin-top: 6px;\n  transition: opacity 0.2s, transform 0.15s;\n}\n.af-submit:hover { opacity: 0.92; transform: translateY(-1px); }\n.af-submit:disabled { opacity: 0.45; cursor: not-allowed; transform: none; }\n\n.af-form-note {\n  font-size: 0.74rem;\n  color: var(--muted2);\n  text-align: center;\n  margin-top: 10px;\n  line-height: 1.5;\n}\n\n/* ── Alert ───────────────────────────────────── */\n.af-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-size: 0.84rem;\n  line-height: 1.5;\n  margin-bottom: 16px;\n}\n.af-alert-ok  { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }\n.af-alert-err { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }\n\n/* ── Responsive ──────────────────────────────── */\n@media (max-width: 860px) {\n  .af-perks-grid { grid-template-columns: repeat(2, 1fr); }\n  .af-steps-grid { grid-template-columns: 1fr; gap: 24px; }\n  .af-stats-inner { grid-template-columns: 1fr; }\n  .af-bottom-form { flex-direction: column; }\n  .af-comm-grid { grid-template-columns: 1fr; }\n  .af-sim-inner { grid-template-columns: 1fr; gap: 36px; }\n}\n\n@media (max-width: 520px) {\n  .af-modal-grid { grid-template-columns: 1fr; }\n  .af-modal-head { padding: 20px 20px 14px; }\n  .af-modal-body { padding: 16px 20px 24px; }\n  .af-perks-grid { grid-template-columns: 1fr; }\n  .af-hero-trust { flex-direction: column; gap: 8px; }\n}\n\n@media (max-height: 760px) {\n  .af-modal { top: 64px; max-height: calc(100vh - 88px); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
